let jotaiDevtoolStyleModule: typeof import('*?inline') | undefined;

if (import.meta.env.DEV) {
  jotaiDevtoolStyleModule = await import('jotai-devtools/styles.css?inline');
}

const defaultStyleModules = import.meta.glob('./**/*.css', {
  query: '?inline',
  import: 'default',
  eager: true,
});

const playerStyleModules = {
  ...defaultStyleModules,
  ...(jotaiDevtoolStyleModule && {
    jotaiDevtoolsStyles: jotaiDevtoolStyleModule.default,
  }),
};

export { playerStyleModules };
